module.exports = __webpack_public_path__ + "static/media/catalog_bg.9d212db2.jpg";